<template lang='pug'>
div(
  v-if='user'
)
  slot(
    v-if='!isAnonymous'
    name='isNotAnonymous'
  )
  slot(
    v-if='isAnonymous'
    name='isAnonymous'
  )
</template>

<script>
import {
  app,
} from '../functions/initializeApp';

import {
  getAuth,
  onAuthStateChanged,
} from 'firebase/auth';

const isAnonymous = function ()
{
  return this?.user?.isAnonymous;
};

const mounted = function ()
{
  const auth = getAuth(app);

  this.unsubscribe = onAuthStateChanged
  (
    auth,
    user => this.user = user
  );
};

const destroyed = function ()
{
  this.unsubscribe();
};

export default
{
  computed:
  {
    isAnonymous,
  },
  mounted,
  data()
  {
    return {
      unsubscribe: null,
      user: null,
    };
  },
  destroyed,
};
</script>